import React from 'react';
import { ChevronRight } from 'lucide-react';
interface CTAButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  subtext?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  subtext,
  variant = 'primary',
  fullWidth = false,
  className = '',
  onClick,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'relative group overflow-hidden font-bold uppercase tracking-wider transition-all duration-300 transform hover:scale-105 active:scale-95';
  const variants = {
    primary: 'bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-500 hover:to-orange-500 text-white shadow-[0_0_20px_rgba(220,38,38,0.5)] border-2 border-red-500/50',
    secondary: 'bg-slate-900 hover:bg-slate-800 text-white border-2 border-blue-500/50 shadow-[0_0_15px_rgba(59,130,246,0.3)]'
  };
  const widthClass = fullWidth ? 'w-full' : 'w-auto';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }
  };
  return <div className={`flex flex-col items-center ${widthClass}`} data-id="element-72">
      <button className={`${baseStyles} ${variants[variant]} ${widthClass} py-4 px-8 rounded-sm ${className}`} onClick={handleClick} {...props} data-id="element-73">
        <span className="relative z-10 flex items-center justify-center gap-2 text-xl md:text-2xl italic" data-id="element-74">
          {children}
          <ChevronRight className="w-6 h-6 animate-pulse" data-id="element-75" />
        </span>

        {/* Shine effect */}
        <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-20 group-hover:animate-shine" data-id="element-76" />
      </button>

      {subtext && <span className="mt-2 text-xs md:text-sm text-slate-400 font-medium tracking-wide uppercase" data-id="element-77">
          {subtext}
        </span>}
    </div>;
}